import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listInventoryLocations = () =>
  axios.get(`${getV1RootUrl()}/inventory-location/pickup`, publicAxiosHeader());
